import ApiService from "../../utils/ApiService";

export const defaultSettingsData = {
  restaurantId: "",
  inventoryType: "",
  invoiceSettingsNameAndLogo: [],
  tableManagement: "",
  /** The below info will be set from api calling and will be pass to update settings */
  paymentOptions: {
    selectedOptionsCustomers: [],
    selectedOptionsAdmins: [],
  },
  acceptPayAfterEat: false,
  kitchenSlipOnly: false,
  isVatIncluded: false,
  takeoutTypes: [],
  posBanks: []
};

export const tableManagementOptions = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

export const getRestaurantSettingsData = async (restaurantId, token) => {
  try {
    const { payload } = await ApiService.GET_BRANCH_WITH_ID(restaurantId, token);

    const formatedData = {
      paymentOptions: {
        selectedOptionsCustomers: payload.customersPaymentOptions,
        selectedOptionsAdmins: payload.adminsPaymentOptions,
      },
      acceptPayAfterEat: payload.acceptPayAfterEat,
      kitchenSlipOnly: payload.kitchenSlipOnly,
      inventoryType: payload.inventoryType,
      isVatIncluded: payload.isVatIncluded,
      invoiceSettingsNameAndLogo: payload.invoiceSettingsNameAndLogo,
      tableManagement: payload.tableManagement,
      takeoutTypes: payload.takeoutTypes,
      posBanks: payload.posBanks
    };

    return {
      success: true,
      settingsData: formatedData,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};

export const getUpdatedGlobalStateRestaurants = (
  tableManagement,
  inventoryType,
  invoiceSettingsNameAndLogo,
  branchId,
  branches,
  parentRestaurants
) => {
  console.log({
    inventoryType,
    invoiceSettingsNameAndLogo,
    branchId,
    branches,
  });
  
  return parentRestaurants.map((pi) => {
    const tmpBranches = pi.branches.map((item) => {
      return branchId === item.restaurantId ? { ...item, inventoryType, invoiceSettingsNameAndLogo, tableManagement } : item;
    });
    return { ...pi, branches: tmpBranches };
  });
};
